export const AUDIT_TABLE_ACTION = { VIEW: "audit-view" };

export const AUDIT_DEFAULT_SORT = { sortBy: "createdOn", orderBy: "desc" };
